import { USE_KEYS, type Me, type UseKey } from "@genbaryoku/contract";
import { useMe } from "../auth.js";

/**
 * 使う機能（B、#142 段3、docs/52 §3）の判定はここ1か所。会社が「使う機能」で OFF にしたものは、ボタン・欄・メニューを隠すだけ
 * （データは残り、紙・金額は変わらない。API では止めない＝門はモジュールの requireModule）。
 * Me を読む前（読み込み中）は全部 ON として扱う（今までの画面のまま）
 */
export function uses(me: Me | null | undefined, k: UseKey): boolean {
  return (me?.tenant.uses ?? USE_KEYS).includes(k);
}

/** 画面用：useUses()("places") */
export function useUses(): (k: UseKey) => boolean {
  const me = useMe();
  return (k) => uses(me.data, k);
}
